<template>
  <div class="calm" :class="extraClass">
    <header class="calm__header">
      <div class="calm__header__row" :style="rowStyle">
        <div class="calm__header__head">
          <div v-if="eyebrow || $slots.eyebrow" class="c-eyebrow">
            <slot name="eyebrow">{{ eyebrow }}</slot>
          </div>
          <h1 class="calm__header__title">
            <slot name="title">{{ title }}</slot>
          </h1>
          <div v-if="sub || $slots.sub" class="calm__header__sub">
            <slot name="sub">{{ sub }}</slot>
          </div>
        </div>
        <div v-if="$slots.actions" class="calm__header__actions">
          <slot name="actions" />
        </div>
      </div>
    </header>

    <div class="calm__body" :style="bodyStyle">
      <div v-if="stats && stats.length" class="calm__stat-grid">
        <div
          v-for="(s, i) in stats"
          :key="s.key || i"
          class="calm__stat"
          :class="s.variant ? 'calm__stat--' + s.variant : null"
        >
          <div class="calm__stat__label">{{ s.label }}</div>
          <div class="calm__stat__value">
            {{ s.value }}<span v-if="s.unit" class="calm__stat__unit">{{ s.unit }}</span>
          </div>
          <div v-if="s.meta" class="calm__stat__meta">{{ s.meta }}</div>
        </div>
      </div>

      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "calm-page",
  props: {
    eyebrow: { type: String, default: "" },
    title: { type: String, default: "" },
    sub: { type: String, default: "" },
    // [{ key?, label, value, unit?, meta?, variant?: 'blue'|'success'|'warning'|'danger' }]
    stats: { type: Array, default: () => [] },
    // override the 1400px max-width on header row + body (number = px, or any CSS length)
    maxWidth: { type: [Number, String], default: null },
    extraClass: { type: [String, Array, Object], default: "" },
  },
  computed: {
    mw() {
      if (this.maxWidth == null) return null;
      return typeof this.maxWidth === "number" ? this.maxWidth + "px" : this.maxWidth;
    },
    rowStyle() {
      return this.mw ? { maxWidth: this.mw } : null;
    },
    bodyStyle() {
      return this.mw ? { maxWidth: this.mw } : null;
    },
  },
};
</script>
